if (!customElements.get('read-more')) {
    customElements.define(
      'read-more',
      class ReadMore extends HTMLElement {
        constructor() {
            super();
            this.contentEle = null;
            this.readMoreEle = null;
        }
  
        handleClick() {
          if (this.contentEle.classList.contains("overflow")) {
            this.readMoreEle.textContent = "Read less -";
          } else {
            this.readMoreEle.textContent = "Read more +";
          }
          this.contentEle.classList.toggle("set-height");
          this.contentEle.classList.toggle("overflow");
        }
  
        handleLoad() {
          if (this.contentEle.scrollHeight > 180) {
            this.contentEle.classList.add("overflow");
  
            this.readMoreEle = document.createElement('p');
            this.readMoreEle.textContent = "Read more +";
            this.readMoreEle.classList.add("read-more");
            this.readMoreEle.classList.add("primary-body");
            this.readMoreEle.addEventListener("click", this.handleClick.bind(this));
  
            this.appendChild(this.readMoreEle);
          }
        }

        handleResize() {
          if (this.contentEle.scrollHeight > 180) {
            if (!this.contentEle.classList.contains("overflow")) {
              this.contentEle.classList.add("overflow");
              this.contentEle.classList.add("set-height");
    
              this.readMoreEle = document.createElement('p');
              this.readMoreEle.textContent = "Read more +";
              this.readMoreEle.classList.add("read-more");
              this.readMoreEle.classList.add("primary-body");
              this.readMoreEle.addEventListener("click", this.handleClick.bind(this));
    
              this.appendChild(this.readMoreEle);
            }
          } else {
            this.contentEle.classList.remove("set-height");
            this.contentEle.classList.remove("overflow");
            this.removeChild(this.readMoreEle);
          }
        }
  
        connectedCallback() {
          this.contentEle = this.querySelector(".read-more-text__content");
          document.addEventListener("DOMContentLoaded", this.handleLoad.bind(this));
          window.addEventListener("resize", this.handleResize.bind(this))
        }
  
        disconnectedCallback() {
          document.removeEventListener("DOMContentLoaded", this.handleResize.bind(this));
          window.removeEventListener("resize", this.handleResize.bind(this))
        }
      }
    );
  }